module.exports = __webpack_public_path__ + "images/mg_small47f7357e17d3132c9538b4b024e0af40.png";